import { CalendarCheck2, MessageCircle } from "lucide-react";
import { CONTACT, IMAGES } from "@/data/siteData";
import { HERO } from "@/constants/testIds";
import { trackBookingClick, trackWhatsappClick } from "@/lib/analytics";

export default function Hero() {
  const wa = `https://wa.me/39${CONTACT.whatsapp}`;
  return (
    <section
      data-testid={HERO.section}
      className="relative overflow-hidden pt-24 md:pt-28"
      style={{ paddingTop: "calc(6rem + var(--announce-h, 0px))" }}
    >
      {/* image (right on desktop, background on mobile) */}
      <div className="absolute inset-0 md:left-1/2 md:right-0 md:w-1/2 hero-gradient overflow-hidden">
        <img
          src={IMAGES.heroDoctor}
          alt="Dr. Cristian Santus, Gastroenterologo"
          className="w-full h-full object-cover"
          style={{ objectPosition: "60% center" }}
          loading="eager"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 min-h-[92vh] md:min-h-[88vh] flex items-center">
        <div className="max-w-2xl md:pr-10 py-16 md:py-0 fade-up">
          <p className="overline">Gastroenterologia · Sardegna</p>
          <h1 className="font-serif text-[44px] leading-[1.05] sm:text-5xl lg:text-6xl mt-6 text-[#0B4A5A]">
            La salute dell'apparato digerente merita attenzione, competenza e
            ascolto.
          </h1>
          <div className="gold-line mt-8 w-24" />
          <p className="mt-8 text-lg text-gray-700 leading-relaxed max-w-xl">
            Visite specialistiche, second opinion e percorsi
            diagnostico-terapeutici personalizzati. Attività
            libero-professionale a Portoscuso, Carloforte, Sestu e Cagliari.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              data-testid={HERO.ctaBook}
              href={CONTACT.miodottore}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackBookingClick("hero")}
              className="btn-primary"
            >
              <CalendarCheck2 size={18} strokeWidth={1.6} />
              Prenota una visita
            </a>
            <a
              data-testid={HERO.ctaWhatsapp}
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsappClick("hero")}
              className="btn-secondary"
            >
              <MessageCircle size={18} strokeWidth={1.6} />
              Contattami su WhatsApp
            </a>
          </div>

          <a
            href="#contatti"
            data-testid="hero-cta-scrivimi"
            className="mt-5 inline-flex items-center gap-1.5 text-[13px] text-gray-500 hover:text-[#0B4A5A] transition-colors group"
          >
            <span className="link-underline">
              Preferisci scrivermi un messaggio?
            </span>
            <span className="text-[#C6A86B] transition-transform group-hover:translate-x-0.5">
              →
            </span>
          </a>

          <div className="mt-12 flex items-center gap-6 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <div className="flex -space-x-0.5">
                {[0, 1, 2, 3, 4].map((i) => (
                  <svg
                    key={i}
                    viewBox="0 0 20 20"
                    className="w-4 h-4 star-gold"
                    aria-hidden
                  >
                    <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9L10 1.5z" />
                  </svg>
                ))}
              </div>
              <span className="font-medium text-gray-800">
                75+ recensioni a 5 stelle
              </span>
            </div>
            <span className="hidden sm:inline text-gray-300">·</span>
            <span className="hidden sm:inline">Medicina basata sulle evidenze</span>
          </div>
        </div>
      </div>
    </section>
  );
}
